import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { format, startOfToday, startOfTomorrow, startOfYesterday } from 'date-fns';
import classNames from 'classnames';
import {
  Tabs,
  Tab
} from '@material-ui/core';
import { isMobileOnly, isTablet } from 'react-device-detect';
import ResizeObserver from 'resize-observer-polyfill';

import './HorseTabs.scss';
import AppContext from '../../../App.context';
import Icon from '../../Icon/Icon';

const TAB = {
  yesterday: 0,
  today: 1,
  tomorrow: 2
};

class HorseTabs extends PureComponent {
  constructor(props) {
    super(props);

    const selectedTab = TAB[props.match.params.type];

    this.state = {
      selectedTab: selectedTab !== undefined ? selectedTab : 1,
      currentWidth: 0
    };

    this.tabs = React.createRef();
  }

  componentDidMount() {
    const { match, getRacingList } = this.props;

    window.addEventListener('resize', this.componentResized);

    setTimeout(() => {
      if (this.tabs.current) {
        this.tabs.current.updateIndicator();
      }
    }, 100);

    const selectedTab = TAB[match.params.type];

    if (selectedTab === 0) {
      getRacingList({ selectedDate: format(startOfYesterday(), 'yyyyMMdd') });
    } else if (selectedTab === 2) {
      getRacingList({ selectedDate: format(startOfTomorrow(), 'yyyyMMdd') });
    } else {
      getRacingList({ selectedDate: format(startOfToday(), 'yyyyMMdd') });
    }

    this.refreshInterval = setInterval(() => {
      if (selectedTab === 0) {
        getRacingList({ hideLoading: true, selectedDate: format(startOfYesterday(), 'yyyyMMdd') });
      } else if (selectedTab === 2) {
        getRacingList({ hideLoading: true, selectedDate: format(startOfTomorrow(), 'yyyyMMdd') });
      } else {
        getRacingList({ hideLoading: true, selectedDate: format(startOfToday(), 'yyyyMMdd') });
      }
    }, 120000);
  }

  componentDidUpdate(prevProps) {
    const { match, getRacingList, setSelectedTab } = this.props;
    if (prevProps.match.params.type !== match.params.type) {
      const selectedTab = TAB[match.params.type];

      if (selectedTab === 0) {
        getRacingList({ selectedDate: format(startOfYesterday(), 'yyyyMMdd') });
        setSelectedTab('yesterday');
      } else if (selectedTab === 2) {
        getRacingList({ selectedDate: format(startOfTomorrow(), 'yyyyMMdd') });
        setSelectedTab('tomorrow');
      } else {
        setSelectedTab('today');
        getRacingList({ selectedDate: format(startOfToday(), 'yyyyMMdd') });
      }

      this.setState({ selectedTab });
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.componentResized);

    if (this.responsiveTab) {
      this.resizeObs.unobserve(this.responsiveTab);
    }

    clearInterval(this.refreshInterval);
  }

  addRef = (el) => {
    this.responsiveTab = el;

    if (this.responsiveTab) {
      this.resizeObs = new ResizeObserver(this.componentResized);
      this.resizeObs.observe(this.responsiveTab);
    }
  }

  componentResized = () => {
    if (this.responsiveTab?.scrollWidth) {
      if (this.responsiveTab.scrollWidth !== this.state.currentWidth) {
        this.setState({ currentWidth: this.responsiveTab.scrollWidth });
      }
    }
  }

  onTabChange = async (e, value) => {
    this.setState({ selectedTab: value });
    this.fetchRacingList(value);
  }

  fetchRacingList = async (value) => {
    const { history, getRacingList } = this.props;
    let tab = '';

    if (value === 0) {
      tab = 'yesterday';
      getRacingList({ selectedDate: format(startOfYesterday(), 'yyyyMMdd') });
    } else if (value === 1) {
      tab = 'today';
      getRacingList({ selectedDate: format(startOfToday(), 'yyyyMMdd') });
    } else {
      tab = 'tomorrow';
      getRacingList({ selectedDate: format(startOfTomorrow(), 'yyyyMMdd') });
    }

    history.replace({
      pathname: tab,
      search: location.search
    });
  }

  dayBefore = () => {
    this.setState({ selectedTab: this.state.selectedTab - 1 });
    this.fetchRacingList(this.state.selectedTab - 1);
  }

  dayAfter = () => {
    this.setState({ selectedTab: this.state.selectedTab + 1 });
    this.fetchRacingList(this.state.selectedTab + 1);
  }

  desktopTabs = () => {
    const { t } = this.props;
    const { selectedTab } = this.state;

    return (
      <div className="tabs">
        <Tabs
          ref={ this.addRef }
          value={ selectedTab }
          onChange={ this.onTabChange }
          action={ this.tabs }
          centered={ true }
          TabIndicatorProps={ { className: 'tabs__container' } }
        >
          <Tab
            label={ t('horseDetail.yesterday') }
            id="simple-tab-0"
            aria-controls="simple-tabpanel-0"
            className={
              classNames({
                'tabs__tab--active' : selectedTab === 0,
                'tabs__tab--inactive': selectedTab !== 0,
                'tabs__tab': true })
            }
          />
          <Tab
            label={ t('horseDetail.today') }
            id="simple-tab-1"
            aria-controls="simple-tabpanel-1"
            className={
              classNames({
                'tabs__tab--active' : selectedTab === 1,
                'tabs__tab--inactive': selectedTab !== 1,
                'tabs__tab': true,
                'tabs__tab--main': true
              })
            }
          />
          <Tab
            label={ t('horseDetail.tomorrow') }
            id="simple-tab-2"
            aria-controls="simple-tabpanel-2"
            className={
              classNames({
                'tabs__tab--active' : selectedTab === 2,
                'tabs__tab--inactive': selectedTab !== 2,
                'tabs__tab': true })
            }
          />
        </Tabs>
      </div>
    );
  }

  singleTab = () => {
    const { t, toggleInfo, showInfo } = this.props;
    const { selectedTab } = this.state;
    let day = <span></span>;

    if (selectedTab === 0) {
      day = <span>{ t('horseDetail.yesterdayRaces') }</span>;
    } else if (selectedTab === 1) {
      day = <span>{ t('horseDetail.todaysRaces') }</span>;
    } else {
      day = <span>{ t('horseDetail.tomorrowRaces') }</span>;
    }

    return (
      <div className="tabs__tab">
        <Icon
          icon="arrow"
          className={
            classNames({
              'tabs__left-arrow': true,
              'tabs__left-arrow--hide': selectedTab < 1
            })
          }
          onClick={ this.dayBefore }
        />

        <div className="tabs__tab-active">
          { day }
          {
            !showInfo ?
              <Icon icon="info" className="tabs__info-icon" onClick={ toggleInfo } />
              :
              <Icon icon="filledI" className="tabs__info-icon tabs__info-icon--selected" onClick={ toggleInfo } />
          }
        </div>

        <Icon
          className={
            classNames({
              'tabs__right-arrow': true,
              'tabs__right-arrow--hide': selectedTab > 1
            })
          }
          icon="arrow"
          onClick={ this.dayAfter }
        />
      </div>
    );
  }

  render() {
    if (isMobileOnly || (isTablet && this.context.isPortrait)) {
      return this.singleTab();
    } else if (!isMobileOnly) {
      return this.desktopTabs();
    }
  }
}

HorseTabs.propTypes = {
  getRacingList: PropTypes.func,
  t: PropTypes.func,
  location: PropTypes.object,
  match: PropTypes.object,
  history: PropTypes.object,
  toggleInfo: PropTypes.func,
  showInfo: PropTypes.bool,
  setSelectedTab: PropTypes.func
};

const mapDispatch = dispatch => ({
  getRacingList: obj => dispatch.events.getRacingList(obj),
  setSelectedTab: tab => dispatch.racing.setSelectedTab(tab)
});

HorseTabs.contextType = AppContext;

export default withRouter(connect(null, mapDispatch)(withTranslation('common')(HorseTabs)));
